/* eslint-disable no-undef */
export default {
	name: "add-or-edit-promotion",
	props:{
		promotionId:{
			default: null
		}
	},
	data() {
		return {
			initialiseActiveFromDate: true,
			initialiseActiveToDate: true,
			promotion:{
				promotionId: null,
				promotionName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				discountAmount: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				promotionDescription: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				activeFromDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				activeToDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				linkedProducts: {
					value: [],
					hasError: false,
					errorMessage: null
				},
				productsToUnlink: [],
				isActive: true
			},
			productsToLinkHeadings:[
				{
					text: "Product",
					field: "productName"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Price After Discount",
					field: "priceAfterDiscountAsString"
				}
			],
			errorModal:{
				modalHeading: "Error",
				elementId: "customerModalError",
				modalMessage: "",
				showModal: false
			},
			successModal:{
				modalHeading: "Success",
				elementId: "customerModalSuccess",
				modalMessage: "",
				showModal: false
			},
			productsLinkingModal: {
				modalHeading: "Link/Unlink Products",
				modalComponentId: "linkProductsToPromotionModal",
				formIsSaving: false,
				showModal: false,
			},
			loading: false,
			loadingFromApi: false
		};
	},
	methods: {
		getPromotion(){
			this.loadingFromApi = true;
			rewardsService.getPromotion(this.promotionId).then(response => {
				if(response.status === 200){
					this.promotion.promotionId = response.data.result.promotionId;
					this.promotion.promotionName.value = response.data.result.promotionName;
					this.promotion.discountAmount.value = response.data.result.discountAmount;
					this.promotion.promotionDescription.value = response.data.result.promotionDescription;
					this.promotion.isActive = response.data.result.isActive;
					// this.promotion.activeFromDate.value = new Date(response.data.result.effectiveFromDate);
					// this.promotion.activeToDate.value = new Date(response.data.result.effectiveFromDate);
					this.promotion.activeFromDate.value = response.data.result.effectiveFromDate;
					this.promotion.activeToDate.value = response.data.result.effectiveToDate;
					// this.promotion.linkedProducts.value = dataTableHelper.castFieldValues(response.data.linkedProducts);
					// for(let i = 0; i < this.promotion.linkedProducts.value.length; i++) {
					// 	this.promotion.linkedProducts.value[i].priceAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].price);
					// 	this.promotion.linkedProducts.value[i].discountAmountAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].discountAmount);
					// 	this.promotion.linkedProducts.value[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].priceAfterDiscount);
					// }
					this.setBreadcrumbs();
				}
				this.loadingFromApi = false;
			});
			// this.promotion.linkedProducts.value = dataTableHelper.castFieldValues(this.promotion.linkedProducts.value);
			// for(let i = 0; i < this.promotion.linkedProducts.value.length; i++) {
			// 	this.promotion.linkedProducts.value[i].priceAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].price);
			// 	this.promotion.linkedProducts.value[i].discountAmountAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].discountAmount);
			// 	this.promotion.linkedProducts.value[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].priceAfterDiscount);
			// }
			this.setBreadcrumbs();
		},
		getPromotionProductsForPromotion(){
			rewardsService.getPromotionProductsForPromotion(this.promotionId).then(response => {
				if(response.status === 200){
					this.promotion.linkedProducts.value = dataTableHelper.castFieldValues(response.data.result);
					for(let i = 0; i < this.promotion.linkedProducts.value.length; i++) {
						this.promotion.linkedProducts.value[i].priceAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].amountIncludingVat);
						this.promotion.linkedProducts.value[i].discountAmountAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].discountAmount);
						this.promotion.linkedProducts.value[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].amountAfterDiscount);
					}
				}
			});
		},
		successModelOkClicked(){
			this.successModal = {
				modalHeading: "Success",
				elementId: "customerModalSuccess",
				modalMessage: "",
				showModal: false
			};
			this.clearModels();
			if(this.isUpdate){
				this.$router.go(-1);
			}
		},
		errorModelOkClicked(){
			this.errorModal = {
				modalHeading: "Error",
				elementId: "customerModalError",
				modalMessage: "",
				showModal: false
			};
		},
		onActiveFromDateSelect(date){
			this.promotion.activeFromDate.value = date;
			this.initialiseActiveFromDate = false;
		},
		onActiveToDateSelect(date){
			this.promotion.activeToDate.value = date;
			this.initialiseActiveToDate = false;
		},
		onDiscountAmountChange(){
			console.log("linkedProducts", this.promotion.linkedProducts.value)
			if(this.promotion.discountAmount.value !== null){
				var hasError = false;
				for(let i = 0; i < this.promotion.linkedProducts.value.length; i++) {
					this.promotion.linkedProducts.value[i].discountAmount = this.promotion.discountAmount.value;
					this.promotion.linkedProducts.value[i].priceAfterDiscount = this.promotion.linkedProducts.value[i].amountIncludingVat - this.promotion.discountAmount.value;
					
					if(this.promotion.linkedProducts.value[i].priceAfterDiscount < 0){
						this.promotion.discountAmount.errorMessage = "Discount amount cannot be greater than product price";
						this.promotion.discountAmount.hasError = true;
						hasError = true;
					}
					this.promotion.linkedProducts.value[i].discountAmountAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].discountAmount);
					this.promotion.linkedProducts.value[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.promotion.linkedProducts.value[i].priceAfterDiscount);
				}
				if(!hasError){
					this.promotion.discountAmount.errorMessage = null;
					this.promotion.discountAmount.hasError = false;
				}
			}
		},
		onLinkProductsClicked() {
			this.productsLinkingModal.showModal = true;
		},
		onLinkProductsToPromotionModalOkClick(){
			this.productsLinkingModal.showModal = false;
		},
		onProductsLinkSaveClicked(selectedAndUnlinkedProducts){
			console.log("selectedAndUnlinkedProducts", selectedAndUnlinkedProducts);
			if(selectedAndUnlinkedProducts.selectedProducts === null || selectedAndUnlinkedProducts.selectedProducts.length === 0){
				this.promotion.linkedProducts.value = [];
			}
			else{
				var hasError = false;
				for(let i = 0; i < selectedAndUnlinkedProducts.selectedProducts.length; i++) {
					var linkedProduct = {
						productId: selectedAndUnlinkedProducts.selectedProducts[i].productId,
						productName: selectedAndUnlinkedProducts.selectedProducts[i].name,
						//productCode: selectedProducts[i].productCode,
						barcode: selectedAndUnlinkedProducts.selectedProducts[i].barcode,
						//productDescription: selectedProducts[i].productDescription,
						amountIncludingVat: selectedAndUnlinkedProducts.selectedProducts[i].amountIncludingVat,
						discountAmount: this.promotion.discountAmount.value === null ? 0 : this.promotion.discountAmount.value, //TODO: set discount amount
						priceAfterDiscount: this.promotion.discountAmount.value === null ? selectedAndUnlinkedProducts.selectedProducts[i].amountIncludingVat : selectedAndUnlinkedProducts.selectedProducts[i].amountIncludingVat - this.promotion.discountAmount.value,
					};
					if(linkedProduct.priceAfterDiscount < 0){
						this.promotion.discountAmount.errorMessage = "Discount amount cannot be greater than product price";
						this.promotion.discountAmount.hasError = true;
						hasError = true;
					}
					linkedProduct.priceAsString = currencyHelper.numberToCurrency(linkedProduct.amountIncludingVat);
					linkedProduct.discountAmountAsString = currencyHelper.numberToCurrency(linkedProduct.discountAmount);
					linkedProduct.priceAfterDiscountAsString = currencyHelper.numberToCurrency(linkedProduct.priceAfterDiscount);
					var productLinked = this.promotion.linkedProducts.value.find(x => x.productId === linkedProduct.productId);
					if(productLinked === null || productLinked === undefined){
						this.promotion.linkedProducts.value.push(linkedProduct);
					}
				}
				if(!hasError){
					this.promotion.discountAmount.errorMessage = null;
					this.promotion.discountAmount.hasError = false;
				}
			}
			
			if(selectedAndUnlinkedProducts.unlinkedProducts !== null && selectedAndUnlinkedProducts.unlinkedProducts.length > 0) {
				for(let j = 0; j < selectedAndUnlinkedProducts.unlinkedProducts.length; j++) {
					this.promotion.linkedProducts.value = this.promotion.linkedProducts.value.filter(x => x.productId !== selectedAndUnlinkedProducts.unlinkedProducts[j].productId);
					this.promotion.productsToUnlink.push(selectedAndUnlinkedProducts.unlinkedProducts[j].productId);
					console.log("promotion.linkedProducts", this.promotion.linkedProducts.value);
				}
			}
			console.log("promotion.linkedProducts", this.promotion.linkedProducts.value);
			this.productsLinkingModal.showModal = false;
		},
		onPromotionUnlink(productId){
			console.log("Unlinking promotion", productId);
			// this.loading = true;
			// let productIdsToUnlink = [];
			// productIdsToUnlink.push(productId);
			// let request = {
			// 	promotionId: this.promotionId,
			// 	productIdsToUnlink: productIdsToUnlink
			// };
			// rewardsService.unlinkProductsFromPromotion(request).then(response => {
			// 	if(response.status === 200){
			// 		let productIndex = this.promotion.linkedProducts.value.findIndex(x => x.productId === productId);
			// 		if(productIndex > -1){
			// 			//remove from linked products
			// 			this.promotion.linkedProducts.value.splice(productIndex, 1);
			// 			this.promotion.productsToUnlink.push(productId);
			// 		}
			// 	}
			// 	this.loading = false;
			// });
			let productIndex = this.promotion.linkedProducts.value.findIndex(x => x.productId === productId);
			if(productIndex > -1){
				//remove from linked products
				this.promotion.linkedProducts.value.splice(productIndex, 1);
				this.promotion.productsToUnlink.push(productId);
			}
		},
		addOrUpdatePromotion(){
			if(!this.promotion.discountAmount.hasError) {
				this.loading = true;
				var productIdsToLink = [];
				for (let i = 0; i < this.promotion.linkedProducts.value.length; i++) {
					productIdsToLink.push(this.promotion.linkedProducts.value[i].productId);
				}

				let request = {
					promotionId: this.promotionId,
					promotionName: this.promotion.promotionName.value,
					promotionDescription: this.promotion.promotionDescription.value,
					discountAmount: this.promotion.discountAmount.value,
					effectiveFromDate: moment(this.promotion.activeFromDate.value).format("DD/MM/YYYY"),
					effectiveToDate: moment(this.promotion.activeToDate.value).format("DD/MM/YYYY"),
					isActive: this.promotion.isActive,
					productIdsToLink: productIdsToLink,
					productIdsToUnlink: this.promotion.productsToUnlink
				};
				rewardsService.addOrUpdatePromotion(request).then(response => {
					if (response.status === 400) {
						this.promotion.promotionName.errorMessage = response.data.promotionValidationResponse.promotionNameValidationResponse.message;
						this.promotion.promotionName.hasError = response.data.promotionValidationResponse.promotionNameValidationResponse.hasError;

						this.promotion.promotionDescription.errorMessage = response.data.promotionValidationResponse.promotionDescriptionValidationResponse.message;
						this.promotion.promotionDescription.hasError = response.data.promotionValidationResponse.promotionDescriptionValidationResponse.hasError;

						this.promotion.discountAmount.errorMessage = response.data.promotionValidationResponse.discountAmountValidationResponse.message;
						this.promotion.discountAmount.hasError = response.data.promotionValidationResponse.discountAmountValidationResponse.hasError;

						this.promotion.activeFromDate.errorMessage = response.data.promotionValidationResponse.effectiveFromDateTimeValidationResponse.message;
						this.promotion.activeFromDate.hasError = response.data.promotionValidationResponse.effectiveFromDateTimeValidationResponse.hasError;

						this.promotion.activeToDate.errorMessage = response.data.promotionValidationResponse.effectiveToDateTimeValidationResponse.message;
						this.promotion.activeToDate.hasError = response.data.promotionValidationResponse.effectiveToDateTimeValidationResponse.hasError;

						this.promotion.linkedProducts.errorMessage = response.data.promotionValidationResponse.productIdsToLinkValidationResponse.message;
						this.promotion.linkedProducts.hasError = response.data.promotionValidationResponse.productIdsToLinkValidationResponse.hasError;
					}
					if (response.status === 200) {
						this.loading = false;
						this.successModal = {
							modalHeading: "Success",
							elementId: "customerModalSuccess",
							modalMessage: "Promotion has been added successfully",
							showModal: true
						};
					}
					this.loading = false;
				});
			}
		},
		onBackClick(){
			this.$router.go(-1);
		},
		clearModels(){
			this.promotion = {
				promotionId: null,
				promotionName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				discountAmount: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				promotionDescription: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				activeFromDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				activeToDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				linkedProducts: {
					value: [],
					hasError: false,
					errorMessage: null
				},
				productsToUnlink: [],
				isActive: true
			};
		},
		setBreadcrumbs() {
			var pageTitle = "Add Promotion";
			if(this.promotionId != null && this.promotionId > 0){
				pageTitle = this.promotion.promotionName.value === null ? "Edit Promotion" : "Edit Promotion - " + this.promotion.promotionName.value;
			}
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		//this.setBreadcrumbs();
		permissionsHelper.setControlsBasedOnPermissions();
	},
	watch: {
		promotionId: {
			handler: function () {
				if (this.promotionId !== null && this.promotionId > 0) {
					this.isUpdate = true;
					this.getPromotionProductsForPromotion();
					this.getPromotion();
				}
				else{
					this.setBreadcrumbs();
					this.isUpdate = false;
				}
			},
			immediate: true,
			deep: true
		}
	}
};